var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("img", {
      staticClass: "backgroundImg",
      attrs: { src: "/static/img/download/Download.jpg" },
    }),
    _vm._v(" "),
    _vm.isWeChatApplet
      ? _c("div", { staticClass: "not-browser-tip" }, [
          _c("img", {
            attrs: {
              src: "data:image/png;base64,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",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "detail" }, [
            _c("div", [
              _vm._v("isWeChatApplet:" + _vm._s(_vm.$nw.UA.isWeChatApplet)),
            ]),
            _vm._v(" "),
            _c("div", [_vm._v("isWeChatApplet:" + _vm._s(_vm.isWeChatApplet))]),
            _vm._v("\n      1. 长按上方二维码保存至本地。"),
            _c("br"),
            _vm._v(
              "\n      2. 用扫一扫扫描相册中已下载的二维码，用手机浏览器打开。"
            ),
            _c("br"),
            _vm._v("\n      3. 下载安装"),
            _c("br"),
          ]),
        ])
      : _vm.$nw.UA.isWeChat
      ? _c("div", { staticClass: "not-browser-tip" }, [
          _c("span", { staticStyle: { "font-size": "25px" } }, [
            _vm._v("点击右上角三个点，选择在浏览器打开"),
          ]),
        ])
      : _c(
          "div",
          [
            _vm.$nw.UA.isAndroid
              ? _c(
                  "van-button",
                  {
                    staticClass: "button",
                    attrs: {
                      type: "primary",
                      size: "normal",
                      url: "http://fir.lvjingservice.com/8gzr",
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "icon",
                      attrs: { src: "/static/img/download/android.png" },
                    }),
                    _vm._v("ANDROID下载"),
                  ]
                )
              : _c(
                  "van-button",
                  {
                    staticClass: "button",
                    attrs: {
                      type: "primary",
                      size: "normal",
                      url: "https://apps.apple.com/cn/app/id1474938537",
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "icon",
                      attrs: { src: "/static/img/download/ios.png" },
                    }),
                    _vm._v("IOS下载"),
                  ]
                ),
          ],
          1
        ),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "beian-footer" }, [
      _vm._v("© 2026 绿晶小程序 |\n    "),
      _c(
        "a",
        { attrs: { href: "https://beian.miit.gov.cn", target: "_blank" } },
        [_vm._v("浙ICP备18033581号")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }